<template>
  <img alt="Vue logo" src="./assets/logo.png" />
  <HelloWorld msg="这是我的学习小站" />
  <div
    style="
      position: fixed;
      text-align: center;
      bottom: 0;
      margin: 0 auto;
      width: 100%;
      color: #5c6b77;
      padding-bottom: 24px;
    "
  >
    <a target="_blank" style="color: #5c6b77" href="https://beian.miit.gov.cn/">
      蜀ICP备2021025134号-1
    </a>
  </div>
</template>

<script>
import HelloWorld from "./components/HelloWorld.vue";

export default {
  name: "App",
  components: {
    HelloWorld,
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
